// Domain helpers for copilot onboarding: derive the sending domain from a
// signup email and tell apart a company mailbox from a free consumer one.

const FREE_MAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "outlook.com",
  "hotmail.com",
  "live.com",
  "yahoo.com",
  "ymail.com",
  "icloud.com",
  "me.com",
  "aol.com",
  "proton.me",
  "protonmail.com",
  "gmx.com",
  "zoho.com",
  "mail.com"
]);

export const getDomainFromEmail = email =>
  typeof email === "string" && email.includes("@")
    ? email.trim().toLowerCase().replace(/.*@/, "")
    : "";

export const isFreeMailDomain = domain =>
  FREE_MAIL_DOMAINS.has((domain || "").trim().toLowerCase());

export default { getDomainFromEmail, isFreeMailDomain };
